import { render, staticRenderFns } from "./WxLocation.vue?vue&type=template&id=c9c7216a"
import script from "./WxLocation.vue?vue&type=script&lang=ts"
export * from "./WxLocation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports